// import React from "react";
// import { Icon } from "@iconify/react";

// export default function TopBar({
//   items = [],
//   cardToOpen = "",
//   setCardToOpen = () => {},
// }) {
//   return (
//     <div className="border-bottom top-bar-feature d-flex">
//       {items.map((item) => (
//         <div
//           key={item.id}
//           className={`px-3 option-list block-card ${
//             cardToOpen === item.id ? "active-card" : ""
//           }`}
//           onClick={() => setCardToOpen(item.id)}
//           id={`${item.id}-list-element`}
//         >
//           {item.icon && <Icon icon={item.icon} className="me-3" />}
//           <p>{item.title}</p>
//         </div>
//       ))}
//     </div>
//   );
// }

import React from "react";

export default function TopBar({
  items = [],
  cardToOpen,
  setCardToOpen,
  classes = "",
  isDisabled = false,
  isShowCount = false,
  countObj = null,
}) {
  return (
    <div className={`topbar-container ${classes}`}>
      {items.map((item) => (
        <button
          key={item.id}
          disabled={isDisabled}
          className={`topbar-item ${cardToOpen === item.id ? "active" : ""}`}
          onClick={() => setCardToOpen(item.id)}
        >
          <span>
            {item.title}{" "}
            {isShowCount && countObj && countObj[item.countName] > -1
              ? `(${countObj[item.countName]})`
              : ""}
          </span>
        </button>
      ))}
    </div>
  );
}
